import type { ReactNode } from 'react';

import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';

import { Iconify } from 'src/components/iconify';

interface StepHeaderProps {
  icon: string;
  title: string;
  children?: ReactNode;
  optionsCount?: number;
}

export const StepHeader = memo(({ icon, title, children, optionsCount = 0 }: StepHeaderProps) => {
  const { t } = useTranslation('shuffle');

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        p: 2,
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        my: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          gap: 2,
          py: 1,
          width: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flex: 1,
            minWidth: 0,
            alignItems: 'center',
            gap: 0.5,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 28,
              height: 28,
              borderRadius: '50%',
              flexShrink: 0,
              p: 0.5,
            }}
          >
            <Iconify icon={icon} width={24} sx={{ color: 'text.primary' }} />
          </Box>
          <Typography variant="h6" sx={{ minWidth: 0 }}>
            {title}
          </Typography>
        </Box>
        {/* {optionsCount > 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ flexShrink: 0 }}>
            {t('createAvailability.optionsCount', { count: optionsCount })}
          </Typography>
        ) : null} */}
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'start',
          flexDirection: 'row',
          gap: 0.5,
          width: '100%',
        }}
      >
        {children}
      </Box>
    </Box>
  );
});

StepHeader.displayName = 'StepHeader';
